export class EventRequestChangeStatusType {
  requestId: number;
  remark: string;

}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-change-status.ts